export default __webpack_public_path__ + "static/media/gallery-2.385fb6a3.jpg";